<button class="group flex cursor-pointer flex-col items-center gap-4 outline-none" tabindex="0">
  <i-star
    class="size-12 rounded-full transition-colors"
    [class]="{
      'text-amber-300': filled(),
      'text-slate-400': !filled(),
      'group-hover:bg-amber-100': filled(),
      'group-hover:bg-slate-100': !filled(),
      'group-focus:bg-amber-100': filled(),
      'group-focus:bg-slate-100': !filled(),
    }"
  />
  @if (label(); as l) {
    <p class="max-w-20 text-center">{{ l }}</p>
  }
</button>
